import React, { useMemo } from "react";
import { AreasList } from "pages/Corporate/CorporateSetupDashboard/MachineCenterDetails/FailureDetailsSettings/AreasList/AreasList.view";
import { Grid } from "@mui/material";
import { FailureDetailsSettingsList } from "components/FailureDetailsSettingsList/FailureDetailsSettingsList.view";
import { useStyles } from "./FailureDetailsSettings.styles";
import { useTranslation } from "react-i18next";
import { FailureDetailsSettingsInstructions } from "./FailureDetailsSettingsIntructions/FailureDetailsSettingsInstructions.view";
import { IFailureDetailsSettingsProps } from "./FailureDetailsSettingsInterfaces";
import { IArea } from "entities/FailureDetailsEntity/FailureDetailsEntityInterfaces";
import { useAreasListContext } from "pages/Corporate/CorporateSetupDashboard/MachineCenterDetails/FailureDetailsSettings/AreasList/context/AreasListContextProvider";

export const FailureDetailsSettings = ({ machineCenter }: IFailureDetailsSettingsProps) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { areas } = useAreasListContext();

    const functionalLocationsCreated = useMemo(
        () => areas.find((area: IArea) => area.functional_locations.length > 0),
        [areas],
    );

    return (
        <Grid container className={classes.container}>
            <Grid item xs={3} className={classes.areaContainer}>
                <AreasList />
            </Grid>
            {functionalLocationsCreated ? (
                <>
                    <Grid item xs={3} className={classes.listContainer}>
                        <FailureDetailsSettingsList
                            title={t("failure_details_setup.failure_type")}
                            listedItems="failureTypes"
                            corporateId={machineCenter?.production_line.mill.corporate_id}
                        />
                    </Grid>
                    <Grid item xs={3} className={classes.listContainer}>
                        <FailureDetailsSettingsList
                            title={t("failure_details_setup.failure_code")}
                            listedItems="failureCodes"
                            corporateId={machineCenter?.production_line.mill.corporate_id}
                        />
                    </Grid>
                    <Grid item xs={3} className={classes.listContainer}>
                        <FailureDetailsSettingsList
                            title={t("failure_details_setup.secondary_failure_code")}
                            listedItems="secondaryFailureCodes"
                            corporateId={machineCenter?.production_line.mill.corporate_id}
                        />
                    </Grid>
                </>
            ) : (
                <Grid item xs={9}>
                    <FailureDetailsSettingsInstructions
                        title={t("failure_details_setup.no_functional_location_added")}
                    />
                </Grid>
            )}
        </Grid>
    );
};
